// theme.ts
import { createTheme } from "@mui/material/styles";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDownOutlined";

const theme = createTheme({
  typography: {
    fontFamily: ["Inter", "sans-serif"].join(","),
  },
  palette: {
    text: {
      primary: "rgba(0, 0, 0, 0.85)",
      secondary: "rgba(0, 0, 0, 0.5)",
      disabled: "rgba(0, 0, 0, 0.7)",
    },
    background: {
      paper: "#ffffff",
    },
    primary: {
      main: "#d80e15",
    },
  },
  components: {
    MuiSelect: {
      defaultProps: {
        IconComponent: KeyboardArrowDownIcon,
      },
      styleOverrides: {
        select: ({ theme: t }) => ({
          padding: "7px 12px",
          backgroundColor: "rgba(0, 0, 0, 0.05)",
          borderRadius: "4px",
          fontWeight: 500,
          fontSize: "12px",
          lineHeight: "1.5",
          color: t.palette.text.primary,
          "&[aria-expanded=true]": {
            backgroundColor: "#D80E15",
            color: theme.palette.background.paper,
          },
          "&.Mui-disabled": {
            color: "rgba(0, 0, 0, 0.3)",
            cursor: "not-allowed",
            opacity: 1,
          },
        }),
        icon: ({ theme: t }) => ({
          fontSize: "16px",
          color: t.palette.text.primary,
          right: "12px",
          transition: "transform 0.2s",
          "&.Mui-focused, &.MuiSelect-iconOpen": {
            color: theme.palette.background.paper,
          },
          "&.Mui-disabled": {
            color: "rgba(0, 0, 0, 0.3)",
          },
        }),
        outlined: {
          border: "none",
          "&:focus": {
            border: "none",
            outline: "none",
          },
          // Disabled стили для outlined варианта
          "&.Mui-disabled": {
            border: "none",
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        notchedOutline: {
          border: "none",
        },
        root: {
          "&:hover .MuiOutlinedInput-notchedOutline": {
            border: "none",
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            border: "none",
          },
          // Disabled стили для OutlinedInput
          "&.Mui-disabled": {
            "&:hover .MuiOutlinedInput-notchedOutline": {
              border: "none",
            },
            "& .MuiOutlinedInput-notchedOutline": {
              border: "none",
            },
          },
        },
      },
    },
    MuiInput: {
      styleOverrides: {
        root: {
          "&:before": {
            borderBottom: "none",
          },
          "&:after": {
            borderBottom: "none",
          },
          "&:hover:not(.Mui-disabled):before": {
            borderBottom: "none",
          },
          "&:hover:not(.Mui-disabled):after": {
            borderBottom: "none",
          },
          "&.Mui-disabled": {
            "&::before": {
              borderBottom: "none",
            },
            "&:after": {
              borderBottom: "none",
            },
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        standard: ({ theme: t }) => ({
          fontWeight: 500,
          fontSize: "12px",
          color: t.palette.text.primary,
          "&.Mui-focused": {
            color: t.palette.text.primary,
          },
          "&.Mui-disabled": {
            color: "rgba(0, 0, 0, 0.26)",
          },
        }),
      },
    },
    MuiMenu: {
      styleOverrides: {
        paper: {
          marginTop: "8px",
          borderRadius: "8px",
          border: "1px solid rgba(0, 0, 0, 0.1)",
          overflowY: "auto",
        },
        list: {
          padding: "8px !important",
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: ({ theme: t }) => ({
          fontSize: "12px",
          fontWeight: 400,
          lineHeight: 1.5,
          padding: "7px 8px",
          color: t.palette.text.primary,
          minHeight: "32px",
          borderRadius: 0,
          backgroundColor: "transparent !important",
          "&:hover": {
            color: t.palette.primary.main,
            backgroundColor: "transparent",
          },
          "&.Mui-selected": {
            backgroundColor: "transparent",
            color: t.palette.primary.main,
          },
          "&.Mui-disabled": {
            color: "rgba(0, 0, 0, 0.3)",
          },
        }),
      },
    },
  },
});

export default theme;
